import { ICellRendererParams } from '@ag-grid-community/core';
import { ReactElement } from 'react';
import DateTimeCellRenderer from '../../../core/components/grid/cell-renderers/DateTimeCellRenderer';
import { WindowsUpdateDto } from '../../models/windows-update';

function InstallationDateTimeCellRenderer({
  value
}: ICellRendererParams<WindowsUpdateDto['installationDateTime']>): ReactElement {
  return <DateTimeCellRenderer value={new Date(value)} />;
}

export default InstallationDateTimeCellRenderer;
